import React from 'react';

import {OutlinedTextFieldProps, TextField as MuiTextField} from '@mui/material';

type Props = Partial<OutlinedTextFieldProps> & {
   variant?: 'outlined';
   onEnter?: (name: string) => void;
   onCancel?: () => void;
};
const TextField = (props: Props) => {
   const {variant = 'outlined', placeholder, disabled, onEnter, onCancel, ...otherProps} = props;
   const label = placeholder;

   return (
      <MuiTextField
         label={label}
         variant={variant}
         fullWidth
         disabled={disabled}
         onKeyDown={
            onEnter || onCancel
               ? (e: React.KeyboardEvent<HTMLInputElement>) => {
                    console.debug('key down', e);
                    e.stopPropagation();
                    if (e.key === 'Enter') onEnter?.((e.target as HTMLInputElement).value);
                    if (e.key === 'Escape') onCancel?.();
                 }
               : (e) => {
                    e.stopPropagation();
                 }
         }
         {...otherProps}
      />
   );
};

export default React.memo(TextField);
